import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import IconButton from "@mui/material/IconButton";
import { useDispatch } from "react-redux";
import {
  requestRemovingUser,
  requestCancelInvitation,
  requestDissociationUser,
} from "../../redux/actions/usersManagementActionCreators";

const DeleteModal = ({
  open,
  handleClose,
  user,
  buttonLabel,
  page,
  searchText,
  tabs,
  filter,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleRemoveUser = (user) => {
    if (user?.role === "enterprise_user" && !user?.status) {
      dispatch(
        requestCancelInvitation(
          user?.id,
          user?.first_name,
          user?.last_name,
          user?.email,
          page,
          searchText,
          tabs,
          filter
        )
      );
    } else if (user?.role === "enterprise_user" && user?.status) {
      dispatch(
        requestDissociationUser({
          id: user?.id,
          first_name: user?.first_name,
          last_name: user?.last_name,
          email: user?.email,
          page: page,
          searchText: searchText,
          tabs: tabs,
          filter: filter,
        })
      );
    } else {
      dispatch(requestRemovingUser(user?.id, page,
        searchText,
        tabs,
        filter));
    }
    handleClose();
  };

  return (
    <div>
      <Dialog
        disableEnforceFocus
        open={open}
        aria-labelledby="draggable-dialog-title"
        onClose={handleClose}
        PaperProps={{ sx: { padding: "40px 10px ", width: "100%" } }}
      >
        <Typography
          variant="subtitle3"
          sx={{ display: "flex", alignItems: "center", mb: 2 }}
        >
          <IconButton onClick={handleClose}>
            <KeyboardBackspaceIcon sx={{ width: "70%", color: "black" }} />
          </IconButton>
          {t("back")}
        </Typography>
        <DialogTitle id="draggable-dialog-title" sx={{ margin: "0px 20px" }}>
          <Typography
            variant="title4"
            sx={{
              fontSize: "25px",
            }}
          >
            {`${t("remove_delete_modal")} ${user?.first_name} ${
              user?.last_name
            }`}
            ?
          </Typography>
        </DialogTitle>{" "}
        <DialogContent sx={{ margin: "10px 20px" }}>
          <DialogContentText>
            {user?.role === "enterprise" && !user?.status ? (
              <strong>{t("role_cancel_modal")}:</strong>
            ) : (
              <strong>{t("role_delete_modal")}:</strong>
            )}
            {t(user?.role)}
          </DialogContentText>
        </DialogContent>
        <DialogActions align="center">
          <Grid container>
            <Grid item xs={12}>
              <Button
                variant="outlined"
                color="deleteButton"
                sx={{ width: "90%" }}
                onClick={() => handleRemoveUser(user)}
                style={{ backgroundColor: "red", color: "white" }}
              >
                {buttonLabel}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DeleteModal;
